import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import {hashHistory} from "react-router";

import {
  toggleSelectionFeatureInfo,
  toggleUserPopup,
  changeSelectionInfoQuantity,
  unlockPricing,
  changeMaterialsInfoFeatureModules,
  addToRecentlyViewed,
  setQtActiveCategory,
  togglePulseFeatureInfoQuantity,
  setCameFromPage
} from "../../../actions/actionFunctions";
import Quantity from "../../ui/quantity";
import InstView from "../../installation/instView";
import Analytics from './../../../analytics';
import {getCurrentLayout} from "../../appLayout";
import FeatureInfoAssociated from "./featureInfoAssociated";
import FeatureInfoDesc from "./featureInfoDesc";
import FeatureInfoPrice from "./featureInfoPrice";
import FeatureInfoImage from "./featureInfoImage";
import FeatureInfoDescription from "./featureInfoDescription";
import FeatureInfoImagesMobile from "./featureInfoImagesMobile";
import {
  canShowSqftButtonForFeature,
  canShowSqftCabinetButtonForFeature,
  getFeatureIsLocked,
  getFeatureUnit
} from "../../../misc/helpers";
import AddProductNoteButton from "../../ui/addProductNoteButton";
import AddProductNoteEditor from "./addProductNoteEditor";
import {MEASURE_UNITS, SQFT_GROUP} from "../../sqft/constants";
import {COUNTERTOP_GROUP} from "../../kvComponent/core/constants";
import {toggleNavItemPositionModal} from "../../../actions/navigationFunctions";
// import {setCartItemEditFeature} from "../../../actions/shoppingCartFunctions";
import {enableSquareFootage, setSqftFromFeature, setSquareFootageGroup} from "../../../actions/sqftFunctions";
import {isEnglish} from "../../../translatesProvider";
import {showWizardInsteadOfQT} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {getFeatureGroupFeaturesQuantity} from "../../look/lookNavigation/lookNavigationFunctions";
import {wizardGroupInterface} from "../../../interfaces/wizardItemInterface";


class FeatureInfo extends Component {

  static propTypes = {
    features: PropTypes.array.isRequired,
    handleFeatureClick: PropTypes.func.isRequired,
    changeActivePartRelatedItem: PropTypes.func.isRequired,
    activePart: PropTypes.object,
    wizardGroup: PropTypes.shape(wizardGroupInterface),
  };

  componentDidMount() {
    const layout = getCurrentLayout();
    const activeFeature = this.props.selectionFeatureInfo;
    if (this.props.fabricatorData.settings.showRecentlyViewedItems) {
      this.props.addToRecentlyViewed(activeFeature);
    }
    // console.log('selectionFeatureInfo', this.props.selectionFeatureInfo);
    const navItemParent = activeFeature.getParent();
    const parentSimple = (navItemParent.partName === "Floor" && navItemParent.partId !== "shower_floor")
      || navItemParent.partName === "Toilet"
      || (navItemParent.partName === "Ceiling" &&
      (document.kvConfig.visualizerType === "Bathroom" || document.kvConfig.visualizerType === "BV"))
      || navItemParent.partName === "Window";
    // console.log('parentSimple', parentSimple);
    // console.log('navItemParent', navItemParent);
    if (parentSimple && !layout.qtCategories) {
      this.props.changeActivePartRelatedItem(0)
    } else {
      const {wizardList, wizardIsActive} = this.props;
      let subParts = [];
      if (layout.qtCategories && this.props.qtActiveCategory && !showWizardInsteadOfQT(wizardList, wizardIsActive)) {
        const qtActiveCategory = layout.qtCategories.find(qtCategory => qtCategory.name === this.props.qtActiveCategory);
        subParts = qtActiveCategory ? qtActiveCategory.subParts : this.props.activePart.subParts(false)
      } else {
        subParts = this.props.activePart.subParts(false);
      }

      const nextActivePartRelatedItemIndex = subParts.findIndex((subPart) => {
        return subPart.part.partId === navItemParent.partId
      });
      // console.log('nextActivePartRelatedItemIndex', nextActivePartRelatedItemIndex);
      this.props.changeActivePartRelatedItem(nextActivePartRelatedItemIndex)
    }
    // console.log('cartItem', cartItem);
    if (this.props.selectionInfoQuantity <= 1) {
      this.props.changeSelectionInfoQuantity(this.getDefaultFeatureQuantity());
    }

    if ((document.kvConfig.visualizerType === "Kitchen" || document.kvConfig.visualizerType === "KV")
      && activeFeature.partId === "top_cabinet" && activeFeature.metaData["Module"]) {
      const activeFeatures = this.props.activePart.layout.getActiveFeatures();
      const materialsInfoFeatureModules = activeFeatures
        .filter(feature => feature.partId.includes("top_cabinet_module"))
        .map(feature => {
          const existInCart = this.props.cartItems.find(cartItem => cartItem.partId === feature.partId);
          return {
            ...feature,
            quantity: existInCart ? existInCart.quantity : feature.quantity
          }
        });
      // console.log("this.props.cartItems", cartItems);
      // console.log("this.props.activePart.layout.getActiveFeatures", activeFeatures);
      this.props.changeMaterialsInfoFeatureModules(materialsInfoFeatureModules)
    }

    if (this.props.navItemPositionModal && this.props.navItemPositionModal.popupOpened) {
      this.props.toggleNavItemPositionModal({
        popupOpened: false,
      });
    }
  }

  componentWillUnmount() {
    this.props.toggleSelectionFeatureInfo(null);
    this.props.changeMaterialsInfoFeatureModules([]);
    this.props.changeSelectionInfoQuantity(1);
    // if (this.props.cartItemEditFeature && !window.location.href.includes("sqft")) {
    //   this.props.setCartItemEditFeature(null);
    // }
  }

  getDefaultFeatureQuantity = () => {
    const activeFeature = this.props.selectionFeatureInfo;
    // const cartItem = this.props.cartItems.find(cartItem => {
    //   return (cartItem.cartFeature.dbFeature.id === activeFeature.dbFeature.id)
    //     && (cartItem.currentQuote === this.props.activeQuoteIndex)
    // });
    // if (cartItem) {
    //   return cartItem.quantity
    // }
    if (this.props.cartItemEditFeature) {
      return this.props.cartItemEditFeature.quantity
    } else if (this.props.advancedQuotingSearchItem) {
      return this.props.advancedQuotingSearchItem.quantity
    }

    const featureGroup = activeFeature.getParent();

    const sqftQuantity = (activeFeature.sqftQuantity && activeFeature.sqftQuantity[this.props.activeQuoteIndex])
      || (featureGroup.sqftQuantity && featureGroup.sqftQuantity[this.props.activeQuoteIndex]);
    if (sqftQuantity) {
      return sqftQuantity
    }

    const defaultOrPositionsQuantity = getFeatureGroupFeaturesQuantity(activeFeature, featureGroup, this.props.wizardGroup);

    if (defaultOrPositionsQuantity && (defaultOrPositionsQuantity !== 1)) {
      return defaultOrPositionsQuantity
    }

    const zeroQuantityPartIdsArray = ["vanity_countertop", "vanity_backsplash", "countertop", "backsplash", "center_island_countertop"];
    if (zeroQuantityPartIdsArray.includes(activeFeature.partId)) {
      return 0
    }

    return 1;
  };

  handleChangeItemQuantity = (quantity) => {
    if (quantity && this.props.pulseFeatureInfoQuantity) {
      this.props.togglePulseFeatureInfoQuantity(false);
    }
    this.props.changeSelectionInfoQuantity(quantity);
  };

  handleSQFTButtonClick = () => {
    Analytics.sendClickEvent("sqft-opened");
    this.props.setCameFromPage(this.props.selectionFeatureInfo);
    this.props.setSqftFromFeature(this.props.cartItemEditFeature || {cartFeature: this.props.selectionFeatureInfo});
    //enable sqft trough redux
    this.props.enableSquareFootage(true);
    this.props.setSquareFootageGroup(SQFT_GROUP.default);

    //enable sqft trough url
    //hashHistory.push("sqft");
  };

  handleSQFTCabnetButtonClick = () => {
    Analytics.sendClickEvent("sqft-opened");
    this.props.setCameFromPage(this.props.selectionFeatureInfo);
    this.props.setSqftFromFeature(this.props.cartItemEditFeature || {cartFeature: this.props.selectionFeatureInfo});
    //enable sqft trough redux
    this.props.enableSquareFootage(true);
    this.props.setSquareFootageGroup(SQFT_GROUP.cabinets);

    //enable sqft trough url
    hashHistory.push("sqft?group=cabinets");
  };

  getFeatureModules = () => {
    const activeFeatures = this.props.activePart.layout.getActiveFeatures();
    return this.props.materialsInfoFeatureModules.map((materialsQuantity, materialsQuantityIndex) => {
      const activeFeature = activeFeatures.find(feature => feature.partId === materialsQuantity.partId);
      return (
        <div className="product-module" key={"materialsQuantity"+materialsQuantityIndex}>
          <div className="product-module__thumbnail" style={{backgroundImage: `url(${materialsQuantity.thumbnail})`}}/>
          <div className="product-module__block">
            <p className={"product-module__block-text"} dangerouslySetInnerHTML={{__html: activeFeature.description}}/>
            <Quantity size="normal"
                      squared={true}
                      changeValue={(quantity) => {
                        const materialsInfoFeatureModules = this.props.materialsInfoFeatureModules.map(mQuantity => {
                          if (mQuantity.partId === materialsQuantity.partId) {
                            mQuantity.quantity = quantity
                          }
                          return mQuantity
                        });
                        this.props.changeMaterialsInfoFeatureModules(materialsInfoFeatureModules);
                      }}
                      value={materialsQuantity.quantity}/>
          </div>
        </div>
      )
    })
  };

  render() {
    const activeFeature = this.props.selectionFeatureInfo;

    if (!activeFeature) {
      return null;
    }

    const {productNoteEditorVisible, fabricatorData, intl, wizardGroup} = this.props;
    const fabricatorSettings = fabricatorData.settings;

    const relatedFeatures = activeFeature.getFeatureRelatedFeatures();
    const associatedProduct = Array.isArray(relatedFeatures) && relatedFeatures.length;

    const showPriceLocked = getFeatureIsLocked(activeFeature);
    const showPrice = fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !showPriceLocked && !fabricatorData.hidePricesFromUser;

    const isMobile = this.props.windowWidth < 991;

    // const showFeatureModules = (document.kvConfig.visualizerType === "Kitchen" || document.kvConfig.visualizerType === "KV")
    //   && activeFeature.partId === "top_cabinet" && activeFeature.metaData["Module"];

    const availableMeasureUnits = [...COUNTERTOP_GROUP, "edge", "edge_profile", "center_island_edge"];
    const unit = getFeatureUnit(activeFeature, intl, fabricatorData, this.props.selectionInfoQuantity);
    const lowerCasedUnit = unit.toLowerCase();
    const allowDecimals = (fabricatorSettings.measureUnit === MEASURE_UNITS.Metric) && (
      availableMeasureUnits.includes(activeFeature.partId) || ["lm", "sm", "mm"].some(um => um === lowerCasedUnit)
    );
    const unitText = activeFeature.getParent ? activeFeature.getParent().unitText : null;

    return (
      <div className="selection-main__info">
        <div className="selection-main__info-scrollable">
          <div className={"product" + (associatedProduct ? " product--associated" : "")}>
            <div className="product-info">
              <FeatureInfoDesc activeFeature={activeFeature}
                               showPrice={showPrice}
                               isMobile={isMobile}
                               showPriceLocked={showPriceLocked}
                               fabricatorSettings={fabricatorSettings} />
            </div>
            <div className="product-actions">
              <h3 className="product-actions__title bold">
                <FormattedMessage id="quotingTool.featureInfo.Title"/>
              </h3>
              {!isMobile ? <AddProductNoteButton/> : null}
              <AddProductNoteEditor wizardGroup={wizardGroup}/>
              <div className={"product-wrapper" + (productNoteEditorVisible ? " product-wrapper--inactive"  : "")}>
                <div className="product-action">
                  {showPrice ? <FeatureInfoPrice mainFeaturePrice={true} /> : null}
                  {activeFeature.dbFeature.hideQuantity ? null :
                    // showFeatureModules
                    //   ? this.getFeatureModules()
                    //   : (
                        <div className="product-action__quantity">
                          <FormattedMessage id="quotingTool.featureInfo.priceLabel"
                                            values={{unit: lowerCasedUnit === "unit"
                                                ? "units"
                                                : lowerCasedUnit === "each" ? null : unit}}
                                            defaultMessage="How many do you need?">
                            {(label) => (
                              <Quantity squared={true}
                                        allowDecimals={allowDecimals}
                                        size={isMobile? "big" : "normal"}
                                        label={unitText && isEnglish(intl.locale) ? unitText : label}
                                        pulseFeatureInfoQuantity={this.props.pulseFeatureInfoQuantity}
                                        changeValue={this.handleChangeItemQuantity}
                                        value={this.props.selectionInfoQuantity}/>
                            )}
                          </FormattedMessage>
                        </div>
                      // )
                  }
                </div>
                {canShowSqftButtonForFeature(activeFeature, fabricatorSettings) ? (
                  <div className="product-action">
                    <button className="ui-button ui-button--sqft ui-button--sqft--small"
                            onClick={this.handleSQFTButtonClick}>
                      <FormattedMessage id="quotingTool.featureInfo.sqftButton"/>
                    </button>
                  </div>
                ) : null}
                {canShowSqftCabinetButtonForFeature(activeFeature, fabricatorSettings) ? (
                  <div className="product-action">
                    <button className="ui-button ui-button--sqft ui-button--sqft--small"
                            onClick={this.handleSQFTCabnetButtonClick}>
                      <FormattedMessage id="quotingTool.featureInfo.sqftCabinetButton"/>
                    </button>
                  </div>
                ) : null}
                {isMobile ? <div className="product-action"><AddProductNoteButton/></div> : null}
              </div>
              {isMobile ? null : <FeatureInfoImage/>}
            </div>
          </div>
          {isMobile ? <FeatureInfoImagesMobile/> : null}
          {isMobile ? <FeatureInfoDescription/> : null}
          {associatedProduct ? <FeatureInfoAssociated handleFeatureClick={this.props.handleFeatureClick}/> : null}
        </div>
        <InstView/>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {selectionInfoQuantity, pulseFeatureInfoQuantity, materialsInfoFeatureModules, selectionGroup,
    selectionFeatureInfo, productNoteEditorVisible, featureInfoCount} = store.selectionState;
  const {cartItems, cartItemEditFeature} = store.cartState;
  const {wizardList, wizardIsActive} = store.wizardState;
  return {
    selectionFeatureInfo,
    selectionGroup,
    selectionInfoQuantity,
    pulseFeatureInfoQuantity,
    materialsInfoFeatureModules,
    productNoteEditorVisible,
    windowWidth: store.serverState.windowWidth,
    cartItems,
    userIsLoggedIn: store.userState.userIsLoggedIn,
    isPriceUnlocked: store.userState.userIsLoggedIn && store.userState.isPhoneNumberValidated,
    fabricatorData: store.fabricatorState,
    qtActiveCategory: store.qtState.qtActiveCategory,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    advancedQuotingSearchItem: store.advancedQuotingState.advancedQuotingSearchItem,
    navItemPositionModal: store.navigationState.navItemPositionModal,
    cartItemEditFeature,
    featureInfoCount,
    wizardList,
    wizardIsActive,
  };
};

const mapDispatchToProps = {
  toggleUserPopup,
  changeSelectionInfoQuantity,
  toggleSelectionFeatureInfo,
  changeMaterialsInfoFeatureModules,
  unlockPricing,
  setCameFromPage,
  addToRecentlyViewed,
  setQtActiveCategory,
  togglePulseFeatureInfoQuantity,
  toggleNavItemPositionModal,
  // setCartItemEditFeature,
  setSqftFromFeature,
  enableSquareFootage,
  setSquareFootageGroup,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(FeatureInfo)
  )
);
